import React, { useState, useContext } from "react";
import { useHistory } from "react-router-dom";
import PropTypes from "prop-types";
import Slider from "react-slick";
import { main_links } from "config";
import CouponSliderItem from "components/CouponSliderItem";
import PopupLayout from "components/PopupLayout";
import PopupTermCond from "components/PopupTermCond";
import PopupCartLimit from "components/PopupCartLimit";
import SessionFactory from "factories/Session";
import CartFactory from "factories/Cart";
import CartService from "services/Cart/service";
import CouponService from "services/Coupon/service";
import { AuthContext } from "../../auth/AuthContext";
import { CartContext } from "../../cart/CartContext";
import { types } from "../../types/types";
import "./style.scss";
import PopupLimiteH from "components/PopupLimiteH";
import PopupMaterials from "components/PopupMaterials";
import PopupCouponRoulette from "components/PopupCouponRoulette";



const CouponSlider = ({
    coupons = [],
    toshow = 6,
    toscroll = 3,
    noslick = false,
    hasSession = false,
    withoutAction = false,
    hasCart = true,
    changeExpired = false,
    maiorLinesMsg=null,
    }) => {
    const { sessionDispatch } = useContext(AuthContext);
    const { cartData, cartDispatch } = useContext(CartContext);
    const history = useHistory();
    const [showTermConditions, setShowTermConditions] = useState(false);
    const [showMaterials, setShowMaterials] = useState(false);
    const [showTermLimiteH, setShowTermLimiteH] = useState(false);
    const [showRoulette, setShowRoulette] = useState(false);
    const [showCartLimit, setShowCartLimit] = useState(false);
    const [popupLegalText, setPopupLegalText] = useState("");
    const [popupMaterialText, setPopupMaterialText] = useState([]);
    const [disponibleLimiteHPopup, setDisponibleLimiteHPopup] = useState(); //popup lh
    const [horaLHPopup, setHoraLHPopup] = useState();//popup lh
    const [cantCupPopup, setCantCupPopup] = useState();//popup lh
    const [disabledCupon, setDisabledCupon] = useState(false);
    const [couponsSlider, setCouponsSlider] = useState(coupons);
    


    const settingSlider = {
        dots: true,
        infinite: true,
        arrows: false,
        slidesToShow: toshow,
        slidesToScroll: toscroll,
        responsive: [
            {
                breakpoint: 280,
                settings: {
                    rows: 1,
                    slidesToShow: 2,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 379,
                settings: {
                    rows: 1,
                    slidesToShow: 2,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 479,
                settings: {
                    rows: 1,
                    slidesToShow: 2,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 537,
                settings: {
                    rows: 1,
                    slidesToShow: 3,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 540,
                settings: {
                    rows: 1,
                    slidesToShow: 3,
                    slidesToScroll: 2,
                },
            },
            {
                breakpoint: 767,
                settings: {
                    rows: 1,
                    slidesToShow: 3,
                    slidesToScroll: 2,
                },
            },
            {
                breakpoint: 768,
                settings: {
                    rows: 1,
                    slidesToShow: 4,
                    slidesToScroll: 2,
                },
            },
            {
                breakpoint: 991,
                settings: {
                    rows: 1,
                    slidesToShow: 5,
                    slidesToScroll: 2,
                },
            },
            {
                breakpoint: 1025,
                settings: {
                    rows: 1,
                    slidesToShow: 5,
                    slidesToScroll: 3,
                },
            },
        ],
    };


    const addToCart = async (coupon) => {
        let cartId =
            cartData?.id && cartData?.state === "A" ? cartData.id : null;

        if (!cartId) {
            try {
                const cartHeader = await CartService.createCartHeader();
                if (
                    !cartHeader ||
                    (cartHeader &&
                        (!cartHeader.payload ||
                            !["200", "201"].includes(cartHeader.internalCode)))
                ) {
                    setDisabledCupon(false);
                    console.error(cartHeader);
                    return;
                }
                cartId = cartHeader.payload.carrito;
            } catch (error) {
                cartDispatch({
                    type: types.update,
                    payload: { ...cartData },
                });
                setDisabledCupon(false);
                console.error(error);
            }
        }
        if (
            cartData?.state === "A" &&
            cartData.items.length == cartData.maxItems
        ) {
            setShowCartLimit(true);
            cartDispatch({
                type: types.update,
                payload: { ...cartData },
            });

            setDisabledCupon(false);
            return;
        }
        if (cartId) {
            //crearCarritoDetalle
           
            try {
                const cartBody = await CartService.createCartBody({
                    carrito: cartId,
                    idcupon: coupon.id,
                });
                //popup limiteH
                if (cartBody.internalCode == "201" && cartBody.payload.cantCupLH!=null) {
                    let disponibleLH = cartBody.payload.disponibleLH;
                    let hora=cartBody.payload.horasLH;
                    let cantCupLH=cartBody.payload.cantCupLH;
                    openLimiteH(disponibleLH,hora,cantCupLH); //manda valor para abrir popup
                    updateCoupons(coupons,coupon,cartBody.payload.disponibleLH); //counter LH
                        
                    
                }
                //end popup limiteH


                if (
                    !cartBody ||
                    (cartBody &&
                        !["200", "201"].includes(cartBody.internalCode))
                ) {

                   //popup cupon agotado
                    if(cartBody && cartBody.internalCode == "406" 
                        && cartBody.payload.disponibleLH == "0")
                        {
                            openLimiteH(cartBody.payload.disponibleLH); //popup LH Agotado
                            updateCoupons(coupons,coupon,cartBody.payload.disponibleLH); //counter LH
                        }else
                    if (cartBody && cartBody.internalCode == "406" ) {
                        localStorage.setItem(
                            "maxLimit",
                            cartBody.payload.maxItems
                        );
                        
                        setShowCartLimit(true);
                        console.log(cartBody, "error");
                    }
                    throw new Error(cartBody);
                }



                if (cartData?.id == cartId) {
                  
                     //logic disponible
                   
                    cartDispatch({
                        type: types.add,
                        payload: { ...coupon },
                    }
                    );
                    

                    setDisabledCupon(false);


                } else {
                    cartDispatch({
                        type: types.update,
                        payload: {
                            ...CartFactory.reset(),
                            id: cartId,
                            state: "A",
                            items: [{ id: coupon.id }],
                        },
                    });
                    setDisabledCupon(false);

                }
            } catch (error) {
                if (cartData?.id == cartId) {
                    cartDispatch({
                        type: types.update,
                        payload: { ...cartData },
                    });
                } else {

                    cartDispatch({
                        type: types.update,
                        payload: {
                            ...CartFactory.reset(),
                            id: cartId,
                            state: "A",
                        },
                    });
        
                }
                setDisabledCupon(false);
                console.error(error);
        
            }
        }
    };
    const removeItem = async (coupon) => {
        try {
            const cartRemove = await CartService.deleteCartBody({
                carrito: cartData.id,
                idcupon: coupon.id,
            });
            if (
                cartRemove &&
                ["200", "201"].includes(cartRemove.internalCode)
            ) {
                cartDispatch({
                    type: types.remove,
                    payload: { ...coupon },
                });
            }
            setDisabledCupon(false);
        } catch (error) {
            cartDispatch({
                type: types.update,
                payload: { ...cartData },
            });
            setDisabledCupon(false);
            console.error(error);
        }
    };
    const couponEvent = (action = "", coupon = {}) => {
        if (!hasSession) {
            history.push(main_links.login);
            return;
        }
        setDisabledCupon(true);
        if (!SessionFactory.validation()) {
            cartDispatch({
                type: types.update,
                payload: CartFactory.reset(),
            });
            sessionDispatch({
                type: types.logout,
            });
            return;
        }

        switch (action) {
            case "add_item":
                addToCart(coupon);
                break;
            case "remove_item":
                removeItem(coupon);
                break;
            default:
                setDisabledCupon(false);
                break;
        }
    };
    const openTermConditions = (event, couponValue = null) => {
        event.preventDefault();
        if (!hasSession) return;
        const newTermCondition = !showTermConditions;
        setPopupLegalText("");
        if (newTermCondition) {
            Promise.all([CouponService.getCouponDetail(couponValue.id)]).then(
                (detail) => {
                    if (detail && detail[0].legal)
                        setPopupLegalText(
                            `${detail[0].legal.availableDates}<br>${detail[0].legal.legalMessage}`
                        );
                }
            );
        }
        setShowTermConditions(newTermCondition);
    };
    const openMaterials= (event, couponValue = null) => {
        event.preventDefault();
        if (!hasSession) return;
        const newMaterials = !showMaterials;
        setPopupMaterialText([]);
        if (newMaterials) {
            Promise.all([CouponService.getCouponDetailMaterial(couponValue.id)]).then(
                (detail) => {

                    if (detail && detail[0].listMaterial){  
                    setPopupMaterialText( detail[0].listMaterial); 
                    }
                }
            );
        }
        setShowMaterials(newMaterials);
    };
    const openRoulette= (event) => {
        const newRoulette = !showRoulette;
        event.preventDefault();
        setShowRoulette(newRoulette);
    };

    const openLimiteH = (disponibleLH,hora,cantCupLHevent, forceValue = "none") => {
        //null no muestra popup
        if (disponibleLH != null) {
            //>0 cupon disponible n horas
            //0 cupon Agotado
            setDisponibleLimiteHPopup(disponibleLH); 
            setHoraLHPopup(hora);
            setCantCupPopup(cantCupLHevent);
            setShowTermLimiteH(
                forceValue === "none" ? !showTermLimiteH : forceValue
            );
        }
    };
    const updateCoupons = (coupons,coupon,disponibleLH) =>
    {
        coupons.map((coupons) => {
            if (coupons.id == coupon.id) {
              coupons.cantCupDisponiblesLH = disponibleLH; //coloca cantidad actualizada 
              //en los coupons
            }
            
       });
     setCouponsSlider(coupons); //actualiza la cantida dispo de coupons
    };

    const openCartLimit = (event, forceValue = "none") => {
        event.preventDefault();
        setShowCartLimit(forceValue === "none" ? !showCartLimit : forceValue);
    };

    
   


    return (
        <>
            {couponsSlider.length && noslick ? (
                <div className="slick-coupon no-slick"> {/*vista home*/}
                    {couponsSlider.map((row, keyRow) => {
                        return (
                            <CouponSliderItem
                                key={keyRow}
                                coupon={row}
                                cart={cartData}
                                eventHandle={withoutAction ? null : couponEvent}
                                controlTerms={openTermConditions}
                                materials={openMaterials}
                                roulette={openRoulette}
                                controlLimiteH={openLimiteH}
                                hasSession={hasSession}
                                disabled={disabledCupon}
                                hasCart={hasCart}
                                changeExpired={changeExpired}
                                linesMsgMaior={maiorLinesMsg}
                               
                            />
                        );
                    })}
                </div>
            ) : coupons.length > 0 &&
              coupons.length < settingSlider.slidesToShow ? (
                <div className="slick-coupon slick-dotted maxw-desk-175 no-slick-v2"> {/* vista para  liberar/*/}
                    {coupons.map((row, keyRow) => {
                        return (
                            <CouponSliderItem
                                key={keyRow}
                                coupon={row}
                                cart={cartData}
                                eventHandle={withoutAction ? null : couponEvent}
                                controlTerms={openTermConditions}
                                controlLimiteH={openLimiteH}
                                hasSession={hasSession}
                                disabled={disabledCupon}
                                hasCart={hasCart}
                                changeExpired={changeExpired}
                                linesMsgMaior={maiorLinesMsg}
                            />
                        );
                    })}
                    
                </div>
            ) : (
                couponsSlider.length > 0 &&
                couponsSlider.length >= settingSlider.slidesToShow && (
                    <Slider
                        className="slick-coupon slick-dotted maxw-desk-175"
                        {...settingSlider}
                    >
                        {couponsSlider.map((row, keyRow) => {
                            return (
                                <CouponSliderItem
                                    key={keyRow}
                                    coupon={row}
                                    cart={cartData}
                                    eventHandle={
                                        withoutAction ? null : couponEvent
                                    }
                                    controlTerms={openTermConditions}
                                    controlLimiteH={openLimiteH}
                                    hasSession={hasSession}
                                    disabled={disabledCupon}
                                    hasCart={hasCart}
                                    changeExpired={changeExpired}
                                    linesMsgMaior={maiorLinesMsg}
                                   
                                />
                            );
                        })}
                    </Slider>
                )
            )}
            <PopupLayout
                isShowwing={showTermConditions}
                showingCallback={openTermConditions}
            >
                <PopupTermCond
                    execActionConfirm={openTermConditions}
                    popupLegalText={popupLegalText}
                />
            </PopupLayout>
            <PopupLayout
                isShowwing={showMaterials}
                showingCallback={openMaterials}
            >
                <PopupMaterials
                    execActionConfirm={openMaterials}
                    popupMaterialText={popupMaterialText}
                    titleText={"Productos de la promoción"}
                />
            </PopupLayout>
            <PopupLayout
                isShowwing={showTermLimiteH}
                showingCallback={openLimiteH}
            >
                <PopupLimiteH
                    execActionConfirm={openLimiteH}
                    disponibleLHPop={disponibleLimiteHPopup}
                    horaLHPop={horaLHPopup}
                    cantCupLHPop={cantCupPopup}
                />
            </PopupLayout>
            <PopupLayout
                isShowwing={showCartLimit}
                showingCallback={openCartLimit}
            >
                <PopupCartLimit execActionConfirm={openCartLimit} />
            </PopupLayout>
            <PopupLayout
                isShowwing={showRoulette}
                showingCallback={openRoulette}
            >
                <PopupCouponRoulette execActionConfirm={openRoulette} />
            </PopupLayout>
        </>
    );
};

CouponSlider.propTypes = {
    coupons: PropTypes.array,
    toshow: PropTypes.number,
    toscroll: PropTypes.number,
    noslick: PropTypes.bool,
    hasSession: PropTypes.bool,
    withoutAction: PropTypes.bool,
    hasCart: PropTypes.bool,
    changeExpired: PropTypes.bool,
    maiorLinesMsg:PropTypes.number,
};

export default CouponSlider;
